import styled from 'styled-components';

export const StyledButtons = styled.div`
  display: flex;
  gap: 1rem;
`;
